"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPushPullReducer = exports.iPushPullInitialState = exports.IPushPullSetCurrentAvailablePages = exports.IPushPullSetCurrentPage = exports.IPushPullSetCurrentFolder = exports.IPushPullSetCurrentReportName = exports.IPushPullLiveReportClear = exports.IPushPullLiveReportSet = exports.IPushPullClearDomainsPages = exports.IPushPullSetDomainsPages = exports.SetIPushPullRunningOff = exports.SetIPushPullRunningOn = exports.SetIPushPullAvailableOff = exports.SetIPushPullAvailableOn = exports.IPushPullAddPage = exports.IPushPullSetLoginErrorMessage = exports.IPushPullSetLoginDetails = exports.IPushPullLogout = exports.IPushPullLogin = exports.IPushPullStopLiveData = exports.IPushPullStartLiveData = exports.IPushPullSendSnapshot = exports.IPushPullSetThrottleTime = void 0;
const GeneralConstants_1 = require("@adaptabletools/adaptable/src/Utilities/Constants/GeneralConstants");
const PluginsRedux_1 = require("@adaptabletools/adaptable/src/Redux/ActionsReducers/PluginsRedux");
const IPushPullSetThrottleTime = (throttleTime) => ({
    type: PluginsRedux_1.IPUSHPULL_SET_THROTTLE_TIME,
    throttleTime,
});
exports.IPushPullSetThrottleTime = IPushPullSetThrottleTime;
const IPushPullSendSnapshot = (iPushPullReport) => ({
    type: PluginsRedux_1.IPUSHPULL_SEND_SNAPSHOT,
    iPushPullReport,
});
exports.IPushPullSendSnapshot = IPushPullSendSnapshot;
const IPushPullStartLiveData = (iPushPullReport) => ({
    type: PluginsRedux_1.IPUSHPULL_START_LIVE_DATA,
    iPushPullReport,
});
exports.IPushPullStartLiveData = IPushPullStartLiveData;
const IPushPullStopLiveData = () => ({
    type: PluginsRedux_1.IPUSHPULL_STOP_LIVE_DATA,
});
exports.IPushPullStopLiveData = IPushPullStopLiveData;
const IPushPullLogin = (username, password) => ({
    type: PluginsRedux_1.IPUSHPULL_LOGIN,
    username,
    password,
});
exports.IPushPullLogin = IPushPullLogin;
const IPushPullLogout = () => ({
    type: PluginsRedux_1.IPUSHPULL_LOGOUT,
});
exports.IPushPullLogout = IPushPullLogout;
const IPushPullSetLoginDetails = (username, password) => ({
    type: PluginsRedux_1.IPUSHPULL_SET_LOGIN_DETAILS,
    username,
    password,
});
exports.IPushPullSetLoginDetails = IPushPullSetLoginDetails;
const IPushPullSetLoginErrorMessage = (errorMessage) => ({
    type: PluginsRedux_1.IPUSHPULL_SET_LOGIN_ERROR_MESSAGE,
    errorMessage,
});
exports.IPushPullSetLoginErrorMessage = IPushPullSetLoginErrorMessage;
const IPushPullAddPage = (folder, page) => ({
    type: PluginsRedux_1.IPUSHPULL_ADD_PAGE,
    folder,
    page,
});
exports.IPushPullAddPage = IPushPullAddPage;
const SetIPushPullAvailableOn = () => ({
    type: PluginsRedux_1.IPUSHPULL_SET_AVAILABLE_ON,
});
exports.SetIPushPullAvailableOn = SetIPushPullAvailableOn;
const SetIPushPullAvailableOff = () => ({
    type: PluginsRedux_1.IPUSHPULL_SET_AVAILABLE_OFF,
});
exports.SetIPushPullAvailableOff = SetIPushPullAvailableOff;
const SetIPushPullRunningOn = () => ({
    type: PluginsRedux_1.IPUSHPULL_SET_RUNNING_ON,
});
exports.SetIPushPullRunningOn = SetIPushPullRunningOn;
const SetIPushPullRunningOff = () => ({
    type: PluginsRedux_1.IPUSHPULL_SET_RUNNING_OFF,
});
exports.SetIPushPullRunningOff = SetIPushPullRunningOff;
const IPushPullSetDomainsPages = (IPushPullDomainsPages) => {
    return {
        type: PluginsRedux_1.IPUSHPULL_DOMAIN_PAGES_SET,
        IPushPullDomainsPages,
    };
};
exports.IPushPullSetDomainsPages = IPushPullSetDomainsPages;
const IPushPullClearDomainsPages = () => {
    return {
        type: PluginsRedux_1.IPUSHPULL_DOMAIN_PAGES_CLEAR,
    };
};
exports.IPushPullClearDomainsPages = IPushPullClearDomainsPages;
const IPushPullLiveReportSet = (iPushPullReport) => ({
    type: PluginsRedux_1.IPUSHPULL_LIVE_REPORT_SET,
    iPushPullReport,
});
exports.IPushPullLiveReportSet = IPushPullLiveReportSet;
const IPushPullLiveReportClear = () => ({
    type: PluginsRedux_1.IPUSHPULL_LIVE_REPORT_CLEAR,
});
exports.IPushPullLiveReportClear = IPushPullLiveReportClear;
const IPushPullSetCurrentReportName = (reportName) => ({ type: PluginsRedux_1.IPUSHPULL_SET_CURRENT_REPORTNAME, reportName });
exports.IPushPullSetCurrentReportName = IPushPullSetCurrentReportName;
const IPushPullSetCurrentFolder = (folder) => ({
    type: PluginsRedux_1.IPUSHPULL_SET_CURRENT_FOLDER,
    folder,
});
exports.IPushPullSetCurrentFolder = IPushPullSetCurrentFolder;
const IPushPullSetCurrentPage = (page) => ({
    type: PluginsRedux_1.IPUSHPULL_SET_CURRENT_PAGE,
    page,
});
exports.IPushPullSetCurrentPage = IPushPullSetCurrentPage;
const IPushPullSetCurrentAvailablePages = (availablePages) => ({
    type: PluginsRedux_1.IPUSHPULL_SET_CURRENT_AVAILABLE_PAGES,
    availablePages,
});
exports.IPushPullSetCurrentAvailablePages = IPushPullSetCurrentAvailablePages;
exports.iPushPullInitialState = {
    IsIPushPullRunning: false,
    IPushPullDomainsPages: GeneralConstants_1.EMPTY_ARRAY,
    CurrentLiveIPushPullReport: undefined,
    IPushPullLoginErrorMessage: undefined,
    IPushPullCurrentReportName: GeneralConstants_1.EMPTY_STRING,
    IPushPullCurrentFolder: GeneralConstants_1.EMPTY_STRING,
    IPushPullCurrentPage: GeneralConstants_1.EMPTY_STRING,
    IPushPullCurrentAvailablePages: GeneralConstants_1.EMPTY_ARRAY,
};
const IPushPullReducer = (
// initial state is handled in the plugin rootReducer
state, action) => {
    switch (action.type) {
        case PluginsRedux_1.IPUSHPULL_SET_AVAILABLE_ON:
            return Object.assign({}, state, { IsIPushPullAvailable: true });
        case PluginsRedux_1.IPUSHPULL_SET_AVAILABLE_OFF:
            return Object.assign({}, state, { IsIPushPullAvailable: false });
        case PluginsRedux_1.IPUSHPULL_SET_RUNNING_ON:
            return Object.assign({}, state, { IsIPushPullRunning: true });
        case PluginsRedux_1.IPUSHPULL_SET_RUNNING_OFF:
            return Object.assign({}, state, { IsIPushPullRunning: false });
        case PluginsRedux_1.IPUSHPULL_SET_LOGIN_DETAILS: {
            let loginAction = action;
            return Object.assign(Object.assign({}, state), { CurrentIPushpullUsername: loginAction.username, CurrentIPushpullPassword: loginAction.password });
        }
        case PluginsRedux_1.IPUSHPULL_LOGOUT: {
            return Object.assign(Object.assign({}, state), { CurrentIPushpullUsername: undefined, CurrentIPushpullPassword: undefined });
        }
        case PluginsRedux_1.IPUSHPULL_SET_LOGIN_ERROR_MESSAGE: {
            return Object.assign(Object.assign({}, state), { IPushPullLoginErrorMessage: action.errorMessage });
        }
        case PluginsRedux_1.IPUSHPULL_DOMAIN_PAGES_SET: {
            return Object.assign({}, state, {
                IPushPullDomainsPages: action.IPushPullDomainsPages || [],
            });
        }
        case PluginsRedux_1.IPUSHPULL_DOMAIN_PAGES_CLEAR: {
            return Object.assign({}, state, {
                IPushPullDomainsPages: [],
            });
        }
        case PluginsRedux_1.IPUSHPULL_LIVE_REPORT_SET: {
            const actionType = action;
            return Object.assign({}, state, { CurrentLiveIPushPullReport: actionType.iPushPullReport });
        }
        case PluginsRedux_1.IPUSHPULL_LIVE_REPORT_CLEAR: {
            // const atctionType = action as IPushPullLiveReportSetAction;
            return Object.assign({}, state, { CurrentLiveIPushPullReport: undefined });
        }
        case PluginsRedux_1.IPUSHPULL_SET_CURRENT_REPORTNAME: {
            const actionTyped = action;
            return Object.assign({}, state, { IPushPullCurrentReportName: actionTyped.reportName });
        }
        case PluginsRedux_1.IPUSHPULL_SET_CURRENT_FOLDER: {
            const actionTyped = action;
            return Object.assign({}, state, { IPushPullCurrentFolder: actionTyped.folder });
        }
        case PluginsRedux_1.IPUSHPULL_SET_CURRENT_PAGE: {
            const actionTyped = action;
            return Object.assign({}, state, { IPushPullCurrentPage: actionTyped.page });
        }
        case PluginsRedux_1.IPUSHPULL_SET_CURRENT_AVAILABLE_PAGES: {
            const actionTyped = action;
            return Object.assign({}, state, {
                IPushPullCurrentAvailablePages: actionTyped.availablePages,
            });
        }
        default:
            return state;
    }
};
exports.IPushPullReducer = IPushPullReducer;
